<template>
  <div>
    <b-skeleton-table
      v-if="isLoading"
      :rows="5"
      :columns="5"
    />

    <b-table
      v-if="!isLoading"
      ref="refInvoiceListTable"
      :items="productRegistries.data"
      responsive
      :fields="tableFields"
      primary-key="id"
      show-empty
      empty-text="No matching records found"
      class="position-relative mh-160"
    >

      <!-- Column: Product -->
      <template #cell(product)="data">
        <b-media vertical-align="center">
          <template #aside>
            <b-img
              class="product-info__image"
              rounded
              width="50"
              :src="linkStaging(data.item.images[0].image_url, 50, 50)"
              alt="Product Image"
              @error="(event) => {
                event.target.src = require('@/assets/images/icons/broken-image.svg')
              }"
            />
          </template>
          <span class="font-weight-bold d-block">
            {{ data.item.name }}
          </span>
          <small class="text-muted">by {{ data.item.merchant.name }}</small>
        </b-media>
      </template>

      <!-- Column: Category -->
      <template #cell(category)="data">
        {{ data.item.category.name }}
      </template>

      <!-- Column: Price -->
      <template #cell(price)="data">
        <span class="text-nowrap">
          {{ toCurrency(data.item.price) }}
        </span>
      </template>

      <!-- Column: Status -->
      <template #cell(user_registry_total)="data">
        <span class="text-nowrap">{{ data.item.registry_count }} Registry</span>
      </template>
    </b-table>

    <div
      class="mx-2 mb-2"
    >
      <pagination
        :data="productRegistries.meta"
        action="products/getProductRegistries"
      />
    </div>
  </div>
</template>

<script>
import {
  BTable,
  BSkeletonTable,
  BMedia,
  BImg,
} from 'bootstrap-vue'
import { mapActions, mapState } from 'vuex'
import Ripple from 'vue-ripple-directive'
import Pagination from '@/layouts/components/custom/Pagination.vue'

export default {
  components: {
    BTable,
    BSkeletonTable,
    BMedia,
    BImg,
    Pagination,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      tableFields: [
        { key: 'product', label: 'Produk' },
        { key: 'category', label: 'Kategori' },
        { key: 'price', label: 'Harga' },
        { key: 'user_registry_total', label: 'Registry' },
        { key: 'action', label: '' },
      ],
      registryUserList: '',
      showUser: false,
    }
  },
  computed: {
    ...mapState('products', ['productRegistries', 'isLoading']),
    query() {
      return this.$route.query
    },
  },
  async created() {
    await this.getProductRegistries(this.query)
  },
  methods: {
    ...mapActions('products', ['getProductRegistries']),
  },
}
</script>
